import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { FiverrLogoMakerLogo, FiverrLogoMakerLightLogo } from '@fiverr-private/visuals';
import { Link } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';
import { INTEGRATIONS } from '../../../constants';
import { useHeaderContext } from '../../context/HeaderContext';
import { useLogoMakerContext } from '../../context/LogoMakerContext';
import {
    DARK_COLOR,
    DESKTOP_LOGO_MAP,
    DESKTOP_LOGO_WIDTH,
    LIGHT_COLOR,
    LINKS,
    MOBILE_LOGO_MAP,
    MOBILE_LOGO_WIDTH,
    reportLogoMakerClick,
} from '../LogoMaker';

export const LogoMakerLogo = () => {
    const { user } = useHeaderContext();
    const { isTransparent, integration } = useLogoMakerContext();
    const path = pathfinder('logo_maker_buyer_landing_page', { user_id: user.username });

    const handleClick = () => {
        reportLogoMakerClick(user.id, LINKS.HOME);
    };

    const hasIntegration = integration && integration !== INTEGRATIONS.NONE;

    if (hasIntegration) {
        const logoColor = isTransparent ? LIGHT_COLOR : DARK_COLOR;
        const DesktopLogo = DESKTOP_LOGO_MAP[integration] || DESKTOP_LOGO_MAP[INTEGRATIONS.NONE];
        const MobileLogo = MOBILE_LOGO_MAP[integration] || MOBILE_LOGO_MAP[INTEGRATIONS.NONE];
        const desktopWidth = DESKTOP_LOGO_WIDTH[integration] ?? DESKTOP_LOGO_WIDTH[INTEGRATIONS.NONE];
        const mobileWidth = MOBILE_LOGO_WIDTH[integration] ?? MOBILE_LOGO_WIDTH[INTEGRATIONS.NONE];

        return (
            <Link href={path} onClick={handleClick}>
                <Container hidden={{ default: true, md: false }} height="auto">
                    <DesktopLogo primaryColor={logoColor} width={desktopWidth} />
                </Container>
                <Container hidden={{ default: false, md: true }} height="auto">
                    <MobileLogo primaryColor={logoColor} width={mobileWidth} />
                </Container>
            </Link>
        );
    }

    return (
        <Link href={path} onClick={handleClick} style={{ display: 'flex' }}>
            {isTransparent ? <FiverrLogoMakerLightLogo /> : <FiverrLogoMakerLogo />}
        </Link>
    );
};
